<template>
  <div>
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.picturePath" alt="" @click="openUrl(item.bannerUrl)" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import codes from '@/api/codes';
export default {
  name: 'Carousel',
  data() {
    return {
      imgList: [],
    };
  },
  mounted() {
    this.initCarouseData();
  },
  methods: {
    initCarouseData() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      let params = {
        location: codes.BIG_CAROUSEL_LOCATION,
      };
      this.$api.getCarouselData(replacement, params).then((data) => {
        this.imgList = data;
      });
    },

    openUrl(url) {
      if (url) {
        window.open(url);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/common.scss';

.van-swipe {
  width: 100%;
  height: 422px;
  box-sizing: border-box;

  .van-swipe__track {
    height: calc-width(170vw);

    img {
      width: 750px;
      height: 422px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Carousel.vue